export const rapidonkeyURL = 'https://rapidonkey.io/';
export const linkedinURL = 'https://www.linkedin.com/company/rapidonkey/';
export const privacyURL = 'https://rapidonkey.io/privacy';
export const termsURL = 'https://rapidonkey.io/terms';
